/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/Footer.js
class Footer {
  constructor() {
    this.titlesSelector = '.footer__block-title';
    this.blockSelector = '.footer__block';
    this.descSelector = '.footer__block-description';
    this.descModifier = 'footer__block-description--reveal';
  }

  init = () => {
    const titles = document.querySelectorAll(this.titlesSelector);
    if (!titles) return;

    titles.forEach((title) => {
      title.addEventListener('click', () => {
        const container = title.closest(this.blockSelector);
        const description = container.querySelector(this.descSelector);

        if (description.classList.contains(this.descModifier)) {
          description.classList.remove(this.descModifier);
        } else {
          description.classList.add(this.descModifier);
        }
      });
    });
  };
}

;// ./src/js/Cart.js
class Cart {
  constructor() {
    this.quantityContainerSelector = '.line-item__quantity-container';
    this.lessSelector = '.line-item__less';
    this.moreSelector = '.line-item__more';
    this.inputSelector = 'input';
  }

  init = () => {
    this.handleQuantityContainer();
    this.setupEventListeners();
  };

  setupEventListeners = () => {
    window.addEventListener('cart:change', (event) => {
      const delay = event.detail.baseEvent === 'variant:add' ? 0 : 1250;
      setTimeout(() => {
        this.handleQuantityContainer();
      }, delay);
    });

    window.addEventListener('cart:refresh', () => {
      console.log('Cart refreshed');
      setTimeout(() => {
        this.handleQuantityContainer();
      }, 500);
    });

    document.addEventListener('line-item:change', (event) => {
      console.log('Line item changed:', event);
      setTimeout(() => {
        this.handleQuantityContainer();
      }, 100);
    });
  };

  handleQuantityContainer = () => {
    const quantityContainers = document.querySelectorAll(
      this.quantityContainerSelector
    );
    if (!quantityContainers.length > 0) return;

    quantityContainers.forEach((quantityContainer) => {
      const less = quantityContainer.querySelector(this.lessSelector);
      const more = quantityContainer.querySelector(this.moreSelector);

      if (!less && !more) return;

      less.removeEventListener('click', this.decrement);
      more.removeEventListener('click', this.increment);

      less.addEventListener('click', (e) => {
        this.decrement(e);
      });

      more.addEventListener('click', (e) => {
        this.increment(e);
      });
    });
  };

  decrement = (event) => { 
    const container = event.target.closest(this.quantityContainerSelector);
    const input = container.querySelector(this.inputSelector);

    input.value = parseInt(input.value) - 1;
    this.triggerChangeEvent(input);
  };

  increment = (event) => {
    const container = event.target.closest(this.quantityContainerSelector);
    const input = container.querySelector(this.inputSelector);

    const max = input.getAttribute('max');

    if (!max || parseInt(input.value, 10) < parseInt(max, 10)) {
      input.value = parseInt(input.value, 10) + 1;
      this.triggerChangeEvent(input);
    }
  };

  triggerChangeEvent = (input) => {
    let event = new Event('change', {
      bubbles: true,
      cancelable: true,
    });
    input.dispatchEvent(event);
  };
}

;// ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// ./src/main.js





// JS goes here
window.addEventListener('load', () => {
  const classes = [new Footer(), new Cart(), new ObfLinks()];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;